import React from 'react';
import './Footer.css';

const Footer = () => {
    const marketingUrl = process.env.REACT_APP_MARKETING_URL || 'https://forge-io.com';
    
    return (
        <div className="footer-section">
            <div className="container">
                <div className="footer-content">
                    {/* Column 1: Logo and Brand */}
                    <div className="footer-column">
                        <div className="footer-logo">
                            <img src="/images/logo.png" alt="Forge Logo" className="footer-logo-img" />
                            <span className="footer-brand">Forge</span>
                        </div>
                    </div>
                    
                    {/* Column 2: Resources */}
                    <div className="footer-column">
                        <h3 className="footer-column-title">Resources</h3>
                        <div className="footer-links">
                            <a href={`${marketingUrl}/services`} className="footer-link">
                                Engineering Services
                            </a>
                        </div>
                    </div>
                    
                    {/* Column 3: Connect */}
                    <div className="footer-column">
                        <h3 className="footer-column-title">Connect</h3>
                        <div className="footer-links">
                            <a href={`${marketingUrl}/contact`} className="footer-link">
                                Contact Us
                            </a>
                            <a href="https://www.linkedin.com/company/forge-io-automation" className="footer-link" target="_blank" rel="noopener noreferrer">
                                <img 
                                    src="https://img.icons8.com/?size=100&id=447&format=png&color=000000" 
                                    alt="LinkedIn"
                                    className="footer-icon"
                                />
                            </a>
                        </div>
                        <p className="footer-location">Headquartered in Seattle, WA</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
